// for Development
// export const PAYMENT_REQUEST_URL = 'https://stagingups.mkcl.org/ups/upsHome/showWelcome'
//export const NOTICE_APP = 'http://stagingnirman.mkcl.org/notice-app'
// export const HEADER_APP = 'http://stagingnirman.mkcl.org/header-app'
// export const FOOTER_APP = 'http://stagingnirman.mkcl.org/footer-app'


// For production
export const FOOTER_APP = 'https://nirman.mkcl.org/footer-app'
export const HEADER_APP = 'https://nirman.mkcl.org/header-app'
export const PAYMENT_REQUEST_URL = 'https://ups.mkcl.org/oasis/ups/upsHome/showWelcome'



// WEBPACK FOOTER //
// ./src/components/common/constants.js